import _styled from "styled-components";
import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import * as styles from "./AccountPopover.styles";
var getTrackingEventWithLabel = function getTrackingEventWithLabel(ev) {
  var _ev$currentTarget$tex;
  return {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'my account click',
    event_label: (_ev$currentTarget$tex = ev.currentTarget.textContent) === null || _ev$currentTarget$tex === void 0 ? void 0 : _ev$currentTarget$tex.trim()
  };
};
export var AccountLink = function AccountLink(_ref) {
  var href = _ref.href,
    text = _ref.text;
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  return /*#__PURE__*/React.createElement(_StyledA, {
    href: href,
    onClick: trackLinkClick(getTrackingEventWithLabel),
    onMouseDown: trackLinkMouseDown(getTrackingEventWithLabel),
    $_css: styles.link
  }, text);
};
var _StyledA = /*#__PURE__*/_styled("a").withConfig({
  displayName: "AccountLink___StyledA",
  componentId: "sc-1w7budv-0"
})(["", ""], function (p) {
  return p.$_css;
});